import { Typography } from "@/frontend/shared/ui/Typography";
import styles from "./Footer.module.scss";
import { useHistoricalNavigate } from "@/frontend/shared/lib/useHistoricalNavigate/useHistoricalNavigate";
import { getRoutePrivacyNotice, getRouteTermsOfUse } from "@/frontend/shared/const/router";

export function Footer() {
  const { navigate } = useHistoricalNavigate();
  const currentYear = new Date().getFullYear();
  return (
    <div className={styles.footer}>
      <div className={styles.container}>
        <Typography
          variant="body-2"
          color="greyscale800"
          className={styles.btn}
          onClick={() => navigate(getRoutePrivacyNotice())}
        >
          Privacy Notice
        </Typography>
        <Typography
          variant="body-2"
          color="greyscale800"
          className={styles.btn}
          onClick={() => navigate(getRouteTermsOfUse())}
        >
          Terms of Use
        </Typography>
      </div>

      <Typography color="greyscale500" variant="body-2" className={styles.copyright}>
        © Copyright Innovera {currentYear}. All rights reserved.
      </Typography>
    </div>
  );
}
